<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <el-button type="primary" size="mini" @click="exportList()">
          导出
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          label="用户ID"
          align="center"
          min-width="20%"
          prop="user_id"
        ></el-table-column>
        <el-table-column
          label="昵称"
          align="center"
          min-width="20%"
          prop="nickname"
        ></el-table-column>
        <el-table-column
          label="手机号"
          align="center"
          min-width="20%"
          prop="mobile_phone"
        ></el-table-column>
        <el-table-column
          label="预约时间"
          align="center"
          min-width="20%"
          prop="created_at"
        ></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getSubscribeList,
} from "@/api/course";

const axios = require('axios');

export default {
    data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      query: {
        target_id: this.$route.query.target_id,
        page: 1,
        limit: 20,
        export: 0
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getSubscribeList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    exportList() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/course/getSubscribeList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '预约列表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    }
  },
  mounted() {},
};
</script>

<style>
</style>